import * as React from "react";

export type StationArrowIconProps = Omit<
  React.SVGProps<SVGSVGElement>,
  "onClick"
> & {
  size?: number | string;
  isOpen?: boolean;
  onToggle?: () => void;
  durationMs?: number;
};

const StationArrowIcon = React.forwardRef<SVGSVGElement, StationArrowIconProps>(
  (
    {
      size = 9,
      isOpen = false,
      onToggle,
      durationMs = 220,
      className,
      style,
      ...props
    },
    ref
  ) => {
    const width = typeof size === "number" ? `${size}px` : size;
    const height =
      typeof size === "number" ? `${(size as number) * (5 / 9)}px` : size;

    return (
      <span
        className="inline-flex"
        style={{
          perspective: "800px",
          lineHeight: 0,
        }}
      >
        <svg
          ref={ref}
          width={width}
          height={height}
          viewBox="0 0 9 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          style={{
            ...style,
            transformStyle: "preserve-3d",
            transformOrigin: "50% 50%",
            transform: isOpen ? "rotateX(180deg)" : "rotateX(0deg)",
            transition: `transform ${durationMs}ms cubic-bezier(0.2, 0.9, 0.2, 1)`,
            cursor: onToggle ? "pointer" : "default",
            userSelect: "none",
            outline: "none",
            border: "none",
            boxShadow: "none",
            WebkitTapHighlightColor: "transparent",
            willChange: "transform",
          }}
          role={onToggle ? "button" : "presentation"}
          tabIndex={onToggle ? 0 : undefined}
          onClick={onToggle}
          onKeyDown={
            onToggle
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onToggle();
                  }
                }
              : undefined
          }
          {...props}
        >
          <path
            d="M8.07268 0.635183L4.35393 4.35393C4.3194 4.38851 4.27838 4.41594 4.23324 4.43465C4.18809 4.45337 4.1397 4.463 4.09083 4.463C4.04196 4.463 3.99357 4.45337 3.94843 4.43465C3.90328 4.41594 3.86227 4.38851 3.82773 4.35393L0.10898 0.635183C0.0392013 0.565405 0 0.470764 0 0.372082C0 0.2734 0.0392013 0.178759 0.10898 0.10898C0.178759 0.0392012 0.2734 0 0.372082 0C0.470764 0 0.565404 0.0392012 0.635183 0.10898L4.09083 3.56509L7.54648 0.10898C7.58103 0.074429 7.62205 0.0470217 7.66719 0.0283229C7.71234 0.00962401 7.76072 0 7.80958 0C7.85845 0 7.90683 0.00962401 7.95197 0.0283229C7.99712 0.0470217 8.03813 0.074429 8.07268 0.10898C8.10723 0.143531 8.13464 0.184549 8.15334 0.229692C8.17204 0.274835 8.18166 0.323219 8.18166 0.372082C8.18166 0.420944 8.17204 0.469328 8.15334 0.514471C8.13464 0.559614 8.10723 0.600632 8.07268 0.635183Z"
            fill="currentColor"
          />
        </svg>
      </span>
    );
  }
);

StationArrowIcon.displayName = "StationArrowIcon";

export default StationArrowIcon;
